import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const navigationManagerSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'navigationManager'

export const config = { site: navigationManagerSiteConfig, name }
